import { ReactElement, useCallback } from 'react';
import { EducationalInformation, MainStudy, Postulant } from '../types';
import { createFetchContext } from '../../../../../components/contexts/FetchContextFactory';
import { Col } from 'reactstrap';
import DisplayError from '../../../../../components/info/DisplayError';
import Loading from '../../../../../components/info/Loading';
import { getPostulantEducationalInformation } from '../../../api/educationalInformationRequests';
import { useParams } from 'react-router-dom';

export interface EducationalInformationLoaderProps {
  children: (props: {
    postulant: Postulant;
    mainStudies: MainStudy[];
    studentId: number;
  }) => ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  EducationalInformation
>();

export function useEducationalInformation() {
  return useFetch();
}

export const EducationalInformationLoaderConsumer = FetchConsumer;

export function EducationalInformationLoader({
  children,
}: EducationalInformationLoaderProps) {
  const { studentId } = useParams<{ studentId: string }>();
  const request = useCallback(async () => {
    return getPostulantEducationalInformation(studentId);
  }, [studentId]);

  return (
    <FetchProvider
      request={request}
      defaultQuery={undefined}
      fetchImmediately={true}
    >
      <FetchConsumer>
        {({ data, loading, error, refresh }) => {
          if (error) {
            return (
              <Col md={12}>
                <DisplayError
                  insideCard
                  textBody={error.code}
                  retryAction={refresh}
                  loadingAction={loading}
                />
              </Col>
            );
          }
          if (loading) {
            return (
              <Col md={12}>
                <Loading insideCard />
              </Col>
            );
          }

          if (!data) {
            return (
              <DisplayError
                insideCard
                textBody="Data no cargada"
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }
          return children({
            postulant: data.postulant,
            mainStudies: data.mainStudies,
            studentId: data.postulant.studentId,
          });
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
